<template>
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-2">
      <div :class="{ 'min-w-16': directFlightsStore.isRoundTrip }">
        <AirlineIcon :airline="{ iata: airline.iata, title: airline.title }" />
      </div>
      <span class="text-text-neutral-primary text-base font-medium">
        {{ airline.title }}
      </span>
    </div>
    <div class="flex items-center gap-1">
      <span
        class="text-text-positive-primary whitespace-nowrap text-sm font-medium"
      >
        {{
          $t('general.price.startFrom', {
            price: prettyPrice(minPrice.toString()),
          })
        }}
      </span>
      <ChevronIcon class="text-text-positive-primary h-4 w-4" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { AirlineIcon } from 'freedom-shared';
  import { prettyPrice } from '@aviata/text-fns';

  import ChevronIcon from '@/assets/images/chevron-arrow-16x16.svg?component';

  import { useDirectFlightsStore } from '../model';
  import type { Airline } from '../types';

  defineProps<{
    airline: Airline;
    minPrice: number;
  }>();

  const directFlightsStore = useDirectFlightsStore();
</script>
